import { DISABLE_ANALYTICS } from 'Global/constants'
import { sendEvent } from 'Global/Helpers/analyticsHelpers'

const analyticsMiddleware = store => next => action => {
  const { meta, payload, type } = action

  if (!DISABLE_ANALYTICS) {
    console.log('sending event') // eslint-disable-line no-console
    sendEvent(type, payload, meta)
  }

  return next(action)
}

export default analyticsMiddleware
